<template>
    <v-dialog v-model="shows" v-bind="$attrs">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card class="rounded-0">
            <v-toolbar>
                <v-img max-width="40" src="/images/icon/icon-dialog.svg" class="v-dialog__icon" />
                <v-spacer />
                <v-btn icon class="v-size--xx-large rounded-0" @click.stop="close"><u-icon>close</u-icon></v-btn>
            </v-toolbar>
            <div class="px-28px pb-28px px-md-60px pb-md-60px">
                <tit v-if="tit" class="tit-wrap--xs text-center mb-20px mb-md-40px"><slot name="tit" /></tit>
                <slot />
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import UIcon from "@/components/publish/styles/icons/u-icon.vue";
import Tit from "@/components/publish/styles/typography/tit.vue";

export default {
    props: {},
    components: {
        UIcon,
        Tit,
    },
    data() {
        return {
            shows: false,
        };
    },
    mounted() {},
    methods: {
        close() {
            this.shows = false;
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .v-dialog {
        border-top: 5px solid var(--v-primary-base);
        &__icon {
            margin-left: var(--container-gutter);
        }
    }
}
</style>
